module.exports = __webpack_public_path__ + "img/4b294a18-45e8-446f-a2d4-e87e7fc7f655.7aa34053.png";